import { render, staticRenderFns } from "./AuthorBox.vue?vue&type=template&id=109f0e02&"
import script from "./AuthorBox.vue?vue&type=script&lang=js&"
export * from "./AuthorBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports